export const DASHBOARD_MESSAGE_CONSTANTS = {
  // Title
  TITLE_DASHBOARD: 'TITLE.DASHBOARD',
  TITLE_DASHBOARD_WIDGET: 'TITLE.DASHBOARD_WIDGET',

    // Success
  SUCCESS_INSERT_DASHBOARD: 'SUCCESS.INSERT_DASHBOARD',
  SUCCESS_UPDATE_DASHBOARD: 'SUCCESS.UPDATE_DASHBOARD',
  SUCCESS_DELETE_DASHBOARD: 'SUCCESS.DELETE_DASHBOARD',

  SUCCESS_INSERT_DASHBOARD_WIDGET: 'SUCCESS.INSERT_DASHBOARD_WIDGET',
  SUCCESS_UPDATE_DASHBOARD_WIDGET: 'SUCCESS.UPDATE_DASHBOARD_WIDGET',
  SUCCESS_DELETE_DASHBOARD_WIDGET: 'SUCCESS.DELETE_DASHBOARD_WIDGET',
};
